module.exports = __webpack_public_path__ + "PnxCspIcons.7ebba4d8b461af02aa7d.svg";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/fonts/PnxCspIcons/fonts/PnxCspIcons.svg?gea4vk
// module id = ../../../../../client/assets/fonts/PnxCspIcons/fonts/PnxCspIcons.svg?gea4vk
// module chunks = styles